import { render, staticRenderFns } from "./LiteUserProfile.vue?vue&type=template&id=06c017da"
import script from "./LiteUserProfile.vue?vue&type=script&lang=js"
export * from "./LiteUserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports